import { useContext } from "react";
import PlanContentPresetsCopyContext from "../context/plan-content-presets-copy.context";
import {
	deleteTemplatesPlansContentPresetImportConfiguration,
	getTemplatesPlansContentPresetImportConfiguration,
} from "../services/plans-template-content-preset-import-configuration.service";

function usePlanContentPresetsCopy() {
	const {
		crudConfOpen,
		setCrudConfOpen,

		crudModel,
		setCrudModel,

		selectedConf,
		setSelectedConf,

		selectedConfId,
		setSelectedConfId,

		copyPopup,
		setCopyPopup,

		planChapters,
		setPlanChapters,

		planData,
		setPlanData,

		organizationData,
		setOrganizationData,

		listConfs,
		setListConfs,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,
		setDeleteConf,

		deleteItem,
		setDeleteItem,

		updateListConf,
		setUpdateListConf,

		listOrganizations,
		setListOrganizations,

		loadingCopyPlan,
		setLoadingCopyPlan,
	} = useContext(PlanContentPresetsCopyContext);

	/**
	 * Update selected configuration
	 * @param {*} newConf
	 */
	const updateSelectedConf = (newConf) => {
		setSelectedConfId(newConf);

		if (newConf != null) updateShowedConf(newConf);
		else setSelectedConf(null);
	};

	/**
	 * Get Copier Detail
	 * @param {*} conf
	 */
	const updateShowedConf = (confId) => {
		setLoadingCopyPlan((loaders) => ({ ...loaders, showDetail: true }));

		getTemplatesPlansContentPresetImportConfiguration(
			{
				templatePlan: planData.template_plan_id,
				contentPreset: planData.content_preset_id,
				importConfiguration: confId,
			},
			(res) => {
				setSelectedConf(res.data);
				setLoadingCopyPlan((loaders) => ({ ...loaders, showDetail: false }));
			}
		);
	};

	/**
	 * Delete selected configuration
	 * @param {*} newConf
	 */
	const deleteConfigurationHandler = (item) => {
		deleteTemplatesPlansContentPresetImportConfiguration(
			{
				templatePlan: planData.template_plan_id,
				contentPreset: planData.content_preset_id,
				importConfiguration: item.id,
			},
			(res) => {
				if (selectedConf?.id === item.id) {
					setSelectedConf(null);
					setSelectedConfId(null);
				}
				setUpdateListConf((i) => i + 1);
			}
		);

		setDeleteModalOpen(false);
	};

	/**
	 * Delete item request
	 * @param {*} item
	 */
	const deleteConfRequest = (item) => {
		setDeleteItem(item);

		setDeleteConf({
			title: "Elimina configurazione",
			icon: "icon_16 default folder",
			subtitle: item.title,
			confirmHandler: deleteConfigurationHandler,
		});

		setDeleteModalOpen(true);
	};

	/**
	 * Edit item request
	 * @param {*} item
	 */
	const editConfRequest = async (item) => {
		if (!loadingCopyPlan.editConf) {
			setLoadingCopyPlan((loaders) => ({ ...loaders, editConf: true }));

			const copier = await getTemplatesPlansContentPresetImportConfiguration({
				templatePlan: planData.template_plan_id,
				contentPreset: planData.content_preset_id,
				importConfiguration: item.id,
			});

			setLoadingCopyPlan((loaders) => ({ ...loaders, editConf: false }));

			setCrudModel(copier?.data);

			setCrudConfOpen(true);
		}
	};

	return {
		crudConfOpen,
		setCrudConfOpen,

		selectedConf,
		setSelectedConf,

		selectedConfId,
		setSelectedConfId,

		updateSelectedConf,

		copyPopup,
		setCopyPopup,

		planChapters,
		setPlanChapters,

		planData,
		setPlanData,

		organizationData,
		setOrganizationData,

		listConfs,
		setListConfs,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,
		setDeleteConf,

		deleteItem,
		setDeleteItem,

		deleteConfigurationHandler,

		updateListConf,
		setUpdateListConf,

		listOrganizations,
		setListOrganizations,

		loadingCopyPlan,
		setLoadingCopyPlan,

		crudModel,
		setCrudModel,
		updateShowedConf,

		deleteConfRequest,
		editConfRequest,
	};
}

export default usePlanContentPresetsCopy;
